import { atomWithStorage } from 'jotai/utils';

import { storage } from '@service-initiation/shared-utils-jotai';

export const repairMessageAtom = atomWithStorage<string>(
  'si-tec-car-repair-message',
  '',
  storage<string>(),
  {
    getOnInit: true,
  }
);
